import firebase from 'firebase/app'
import "firebase/firestore";
import "firebase/storage";
import dbRefs from '@/store/modules/dbRefs'

export const defineDbRefs = function () {
  //
  dbRefs.state.storage = firebase.storage() //storage
  //
  firebase.firestore().enablePersistence()
    .then(function () {
      //console.log('// Initialize Cloud Firestore through firebase')
      dbRefs.state.firestore = firebase.firestore(); //got firestore ref
      //console.log("firestore =>", state.firestore)
      dbRefs.state.dbRefLoader = false
    })
    .catch(function (err) {
      if (err.code == 'failed-precondition') {
        //console.log('// Multiple tabs open, persistence can only be enabled // in one tab at a a time.')
        dbRefs.state.firestore = firebase.firestore();  //got firestore ref
        //console.log("firestore =>", state.firestore)
      } else if (err.code == 'unimplemented') {
        //console.log(' // The current browser does not support all of the // features required to enable persistence')
        dbRefs.state.firestore = firebase.firestore();  //got firestore ref
        //console.log("firestore =>", state.firestore)
      }
      //
      dbRefs.state.dbRefLoader = false
    });
}



// WEBPACK FOOTER //
// ./src/helper/dbRefs.js